import { render } from "./topic_set_by.vue?vue&type=template&id=18f4146e&ts=true"
import script from "./topic_set_by.vue?vue&type=script&lang=ts"
export * from "./topic_set_by.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/topic_set_by.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18f4146e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18f4146e', __exports__)) {
    api.reload('18f4146e', __exports__)
  }
  
  module.hot.accept("./topic_set_by.vue?vue&type=template&id=18f4146e&ts=true", () => {
    api.rerender('18f4146e', render)
  })

}


export default __exports__